import { useTransition } from "react-spring";
import { animated } from "react-spring";
import { Pages } from "./content/page";
import { Button } from "@mui/material";
import { useState } from "react";

const Project = () => {
    const forward = ['//'];

    const [i,setI]=useState(0);

    const transition = useTransition(1, {
        from: { x: 0, opacity: 0 },
        enter: { opacity: 1 },
        leave: { opacity:0 },
    });

    return (
        <div className="projects">
            <h1>{forward}Projects</h1>
            {
                transition((style, item) => item ?
                    <animated.div style={style}>
                        <div className="sites">
                            {
                                <div className="site">
                                    <div className="page">
                                        {
                                            transition((style,item)=>item?
                                                <img style={style} src={Pages[i].image} alt="imgg"></img>:""
                                            )
                                        }
                                        <span className="buttons">
                                            <Button variant="text"
                                            onClick={
                                                ()=>{
                                                    if(i===0)
                                                        setI(4);
                                                    else
                                                        setI(i-1);
                                                }
                                            }
                                            > {"<"} </Button>
                                            <Button variant="text"
                                                onClick={()=>{
                                                    if(i===4)
                                                        setI(0);
                                                    else
                                                        setI(i+1);
                                                }}
                                            > {">"}</Button>
                                        </span>
                                    </div>
                                    <div className="description">
                                        <h1>{Pages[i].name}</h1>
                                        <div>
                                            We are looking for an Accounts Payable Specialist to join our team and work with our accounting department to oversee our organization’s expenses.
                                            Accounts Payable Specialist responsibilities include processing payments, verifying invoices and performing account reconciliations as needed.
                                            Ultimately, you will work with our accounting team to ensure our organization’s expenditures are accurate and our accounting practices are standardized across the organization.
                                        </div>
                                    </div>
                                </div>
                            }

                        </div>
                    </animated.div> : ""
                )
            }

        </div>
    );
}

export default Project;
